const config = useRuntimeConfig()

export default function useNews() {
    const getNews = async (perPage = 10, page = 1) => {
        try {
            const {
                data,
                error
            } = await useFetch(() => `${config.public.baseUrlBackend}/api/news?page=${page}&perPage=${perPage}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            })

            if (error?.value) {
                return error.value.data
            } else if (data.value) {
                return data.value
            } else {
                return {error: 'Unknown response format'};
            }
        } catch (error) {
            console.log('Erro: ', error)
            return []
        }
    };

    const getNewsByTag = async (tag: string, limit: number) => {

        try {
            const {data, error} = await useFetch(() => `${config.public.baseUrlBackend}/api/news/tag/${tag}?limit=${limit}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });

            if (error?.value) {
                return error.value
            } else if (data.value) {
                return data.value
            } else {
                return {error: 'Unknown response format'};
            }
        } catch (error) {
            console.log('Erro: ', error)
            return []
        }
    };

    const getHighlightNews = async () => {
        try {
            const {data, error} = await useFetch(() => `${config.public.baseUrlBackend}/api/news/highlight/true`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });

            if (error?.value) {
                return error.value.data
            } else if (data.value) {
                return data.value
            } else {
                return {error: 'Unknown response format'};
            }
        } catch (error) {
            console.log('Erro: ', error)
            return []
        }
    };

    return {
        getNews,
        getNewsByTag,
        getHighlightNews
    }
}
